export var BogMerchantStatusEnum;
(function (BogMerchantStatusEnum) {
    BogMerchantStatusEnum["DECLINED"] = "DECLINED";
    BogMerchantStatusEnum["ERROR"] = "ERROR";
    BogMerchantStatusEnum["PROCESSING"] = "PROCESSING";
    BogMerchantStatusEnum["SUCCESS"] = "SUCCESS";
    BogMerchantStatusEnum["MISSING_FIELDS"] = "MISSING_FIELDS";
    BogMerchantStatusEnum["CONFLICTING"] = "CONFLICTING";
    BogMerchantStatusEnum["UNSUPPORTED_TRANSACTION"] = "UNSUPPORTED_TRANSACTION";
    BogMerchantStatusEnum["FINALIZED"] = "FINALIZED";
})(BogMerchantStatusEnum || (BogMerchantStatusEnum = {}));
//# sourceMappingURL=bog-merchant-status.enum.js.map